import React from 'react';


export default ({color, fontSize=15}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={fontSize} height={fontSize} viewBox="0 0 15 15">
      <path fill={color || '#0092e5'} d="M393.5,667.5H392a1.5,1.5,0,0,0-1.5,1.5v4.5A1.5,1.5,0,0,0,392,675h1.5a1.5,1.5,0,0,0,1.5-1.5V669A1.5,1.5,0,0,0,393.5,667.5Zm0,5.25a.75.75,0,0,1-1.5,0v-3a.75.75,0,0,1,1.5,0ZM383,663h-1.5a1.5,1.5,0,0,0-1.5,1.5v9a1.5,1.5,0,0,0,1.5,1.5H383a1.5,1.5,0,0,0,1.5-1.5v-9A1.5,1.5,0,0,0,383,663Zm0,9.75a.75.75,0,0,1-1.5,0v-7.5a.75.75,0,0,1,1.5,0ZM388.25,660h-1.5a1.5,1.5,0,0,0-1.5,1.5v12a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5v-12A1.5,1.5,0,0,0,388.25,660Zm0,12.75a.75.75,0,0,1-1.5,0v-10.5a.75.75,0,0,1,1.5,0Z" transform="translate(-380 -660)"/></svg>
  )
}